import React from 'react';

function ComponentHeader(props) {
  const headerWithNoSubheading = {
    paddingBottom: '24px',
  };

  const headerWithSubheading = {
    paddingBottom: '6px',
  };

  const secondaryColorBar = {
    height: '3px',
    width: '62px',
    backgroundColor: `${props.tenant.secondary}`,
  };

  const headerType = props.mainHeader ? (
    <h1
      className="header-text"
      data-cy="section-header-text"
      style={
        props.subheadingText ? headerWithSubheading : headerWithNoSubheading
      }
    >
      {props.headerText}
    </h1>
  ) : (
    <h2
      className={props.headerStyle ? props.headerStyle : 'header-text'}
      data-cy="section-header-text"
      style={
        props.subheadingText ? headerWithSubheading : headerWithNoSubheading
      }
    >
      {props.headerText}
    </h2>
  );
  return (
    <div
      id={`component-header-${
        props.appendText || props.headerText.replaceAll(' ', '-').toLowerCase()
      }`}
      tabIndex={-1}
      className={[props.overRideStyle, 'component-header'].join(' ').trim()}
    >
      {headerType}
      {props.subheadingText ? (
        <div className="subheading-text">{props.subheadingText}</div>
      ) : null}
      <div style={secondaryColorBar} />
    </div>
  );
}

export default ComponentHeader;
